import React, { useEffect, useRef } from 'react';
import lottie from 'lottie-web';

const LottieView = React.forwardRef(({ autoPlay, className, loop, source, style }, ref) => {

    const animation = useRef(null);
    const container = useRef(null);

    const play = (start, end) => {
        if(!isNaN(start) && !isNaN(end)) {
            animation.current.playSegments([start, end], true);
            return;
        }
        animation.current.play();
    }

    const reset = () => {
        animation.current.goToAndStop(0, true);
    }

    const reverse = props => {
        animation.current.setDirection(-1);
        play(props);
    }

    useEffect(() => {
        if(ref && ref.current) {
            ref.current.play = play;
            ref.current.reset = reset;
            ref.current.reverse = reverse;
        }
    }, [ref]);

    useEffect(() => {
        animation.current = lottie.loadAnimation({
            animationData: source,
            autoplay: autoPlay,
            container: container.current,
            loop: loop,
            renderer: 'svg',
            rendererSettings: { preserveAspectRatio: 'xMidYMid slice' },
        });
    }, [])

    return (
        <div
        ref={ref}
        className={className}
        style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '100%',
            height: '100%',
            ...style
        }}>
            <div ref={container} />
        </div>
    )
})
export default LottieView;
